//
// Sticky Contact
// Switch button content when sticky contact is open
//
$('#stickyContact').on('shown.bs.collapse', function () {
    $(this).prev('button').find('span').toggleClass('d-block');
});

$('#stickyContact').on('hidden.bs.collapse', function () {
    $(this).prev('button').find('span').toggleClass('d-block');
});